<dx-accordion
        class="versionsContainer"
        [dataSource]="versions"
        keyExpr="createdOn"
        [collapsible]="true"
        [multiple]="true"
        itemTitleTemplate="header"
        itemTemplate="content">

    <div *dxTemplate="let version of 'header'" class="versionsHeader">
        <div>
            Creation Date: {{ getCreationDate(version.createdOn) }}
        </div>
    </div>

    <div *dxTemplate="let version of 'content'" class="versionsContent">
        <dx-text-area
                class="width-100 versionsText"
                [value]="version.content"
                [readOnly]="true"
                [height]="150">
        </dx-text-area>

        <dx-button
                class="versionsButton"
                icon="undo"
                text="Restore Version"
                type="default"
                stylingMode="outlined"
                (onClick)="onRestore({ version: version })">
        </dx-button>
    </div>

</dx-accordion>

